import { ApolloError } from '@apollo/client';
import Typography from '@mui/material/Typography';
import React from 'react';

interface Props {
  error?: ApolloError;
  message?: string;
}

export const ErrorPage = ({ error, message }: Props) => {
  return (
    <div
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* align center is default for mui typography */}
      <>
        <Typography variant='h1'>ERROR</Typography>
        <Typography>{error?.message || message}</Typography>
      </>
    </div>
  );
};
